import { extractTeams, replaceEnrichedName } from 'bto-models/utils/string';
export default class BetSlipDetailsEvent {
  constructor(data) {
    /**
     * @type {string}
     * Match Title for Boosted Odds
     */
    this.matchTitle = data.mt;
    /**
     * @type {string}
     * Event name without the () part
     */
    this.eventName = data.mt.split(/\s+\(/)[0].trim();
    /**
     * @type {string}
     * Split the event name with the vs keyword
     * @description Home Team name from the event name
     */
    this.homeTeam = extractTeams(this.eventName).homeTeam;
    /**
     * @type {string}
     * Split the event name with the vs keyword
     * @description Away Team name from the event name
     */
    this.awayTeam = extractTeams(this.eventName).awayTeam;
    /**
     * @type {string}
     * Special Bet Value
     * @description Special Bet Value
     */
    this.sbv = data.sbv || null;
    /**
     * @type {string}
     * Bet Builder Markets Displayed
     * @description Enriched Outcome Name with home and away team
     */
    this.betBuilderMarket = replaceEnrichedName(data.m, this.homeTeam, this.awayTeam, data.sbv);
    /**
     * @type {string}
     * General Outcome Name
     * @description Outcome Name with home and away team
     */
    this.outcomeName = replaceEnrichedName(data.on, this.homeTeam, this.awayTeam, data.sbv);
    /**
     * @type {string}
     * General Market Name
     * @description Market Name with home and away team
     */
    this.marketName = replaceEnrichedName(data.otn, this.homeTeam, this.awayTeam, data.sbv);
    /**
     * @type {booelan}
     * @description If the match is US layout
     */
    this.isUsLayout = data.tus || false;
    /**
     * @type {number}
     * @description Item type of the event
     */
    this.itemType = data.itid || 0;
  }
}